module.exports = "<router-outlet></router-outlet>\n<notify-container #notifyContainer></notify-container>\n<page-loader #pageLoader></page-loader>\n"